

// ── Tidal Vape PWA Install Handler (FIXED) ────────── 

let deferredPrompt = null; 

// ── Helper: is this iOS? ─────────────────────────────
function isIos() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
function isInStandaloneMode() {
  return (window.navigator.standalone === true) ||
    window.matchMedia('(display-mode: standalone)').matches;
}

// ── Show the button safely after DOM is ready ────────
function showInstallButton(type) {
  function reveal() {
    var btn = document.getElementById('tv-pwa-install-btn');
    if (btn) {
      btn.style.display = 'flex';
      btn.setAttribute('data-type', type);
    }
  }
  // If DOM already loaded, run now. Otherwise wait.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
}

// ── Android/Chrome: catch install prompt ─────────────
window.addEventListener('beforeinstallprompt', function(e) {
  e.preventDefault();
  deferredPrompt = e;
  showInstallButton('android');
});

// ── iOS: show button if on iPhone/iPad, not installed ─
if (isIos() && !isInStandaloneMode()) {
  showInstallButton('ios');
}

// ── Register Service Worker ──────────────────────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker
      .register('{{ "service-worker.js" | asset_url }}')
      .then(function(reg) {
        console.log('Tidal Vape SW registered');
      }).catch(function(err) {
        console.log('SW error:', err);
      });
  });
}

// ── Button click handler ─────────────────────────────
function handleInstallClick() {
  var btn = document.getElementById('tv-pwa-install-btn');
  var type = btn ? btn.getAttribute('data-type') : '';

  if (type === 'android' && deferredPrompt) {
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then(function(result) {
      if (result.outcome === 'accepted') { showSuccessState(); }
      deferredPrompt = null;
    });
  } else if (type === 'ios') {
    showIosPopup();
  }
}

function showSuccessState() {
  var btn = document.getElementById('tv-pwa-install-btn');
  if (btn) {
    btn.innerHTML = '<span>✓ App Installed!</span>';
    btn.style.background = '#00e5a0';
    btn.style.color = '#0a1628';
    btn.style.cursor = 'default';
  }
}

function showIosPopup() {
  var existing = document.getElementById('tv-ios-popup');
  if (existing) { existing.remove(); return; }
  var popup = document.createElement('div');
  popup.id = 'tv-ios-popup';
  popup.innerHTML = `
    <div style="
      position:fixed; bottom:0; left:0; right:0; z-index:99999;
      background:#0f2044; border-top:2px solid #00c2a8;
      padding:24px 20px 32px; font-family:sans-serif;
      animation: slideUp 0.3s ease;
    ">
      <style>@keyframes slideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}</style>
      <button onclick="document.getElementById('tv-ios-popup').remove()" style="
        position:absolute; top:12px; right:16px;
        background:none; border:none; color:#6b8ea8;
        font-size:22px; cursor:pointer; line-height:1;
      ">×</button>
      <div style="display:flex;align-items:center;gap:12px;margin-bottom:20px;">
        <img src="https://cdn.shopify.com/s/files/1/0010/5902/9110/files/icon-192.png?v=1771331548" style="width:48px;height:48px;border-radius:10px;" />
        <div>
          <div style="font-weight:700;color:#fff;font-size:16px;">Install Tidal Vape</div>
          <div style="color:#6b8ea8;font-size:13px;">Add to your Home Screen</div>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;gap:12px;">
        <div style="display:flex;align-items:center;gap:14px;background:rgba(0,194,168,0.08);border:1px solid rgba(0,194,168,0.2);border-radius:10px;padding:12px 16px;">
          <div style="font-size:26px;flex-shrink:0;">1️⃣</div>
          <div style="color:#c8dae8;font-size:14px;">Tap the <strong style="color:#00c2a8;">Share button</strong> at the bottom of Safari <span style="font-size:18px;">⬆️</span></div>
        </div>
        <div style="display:flex;align-items:center;gap:14px;background:rgba(0,194,168,0.08);border:1px solid rgba(0,194,168,0.2);border-radius:10px;padding:12px 16px;">
          <div style="font-size:26px;flex-shrink:0;">2️⃣</div>
          <div style="color:#c8dae8;font-size:14px;">Scroll down and tap <strong style="color:#00c2a8;">"Add to Home Screen"</strong></div>
        </div>
        <div style="display:flex;align-items:center;gap:14px;background:rgba(0,194,168,0.08);border:1px solid rgba(0,194,168,0.2);border-radius:10px;padding:12px 16px;">
          <div style="font-size:26px;flex-shrink:0;">3️⃣</div>
          <div style="color:#c8dae8;font-size:14px;">Tap <strong style="color:#00c2a8;">"Add"</strong> in the top right corner</div>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(popup);
}

// ── Already installed? Show success ──────────────────
window.addEventListener('appinstalled', function() {
  showSuccessState();
});